<template>
    <div id="distance" fill-height class="fill-height" style="width:100%; position:relative; background: #FFF;">
      <m-client-form :form="formClient" :user="clientItem" :dialog="dialog_client" @save="saveClient" @close="closeClient"  ></m-client-form>
      <m-destination-form :form="formDestination" :destination="destinationItem" :dialog="dialog_destination" @save="saveDestination" @close="closeDestination" ></m-destination-form>

    <div class="distance-controller pa-3">
      <v-layout wrap>
        <v-flex>
          <div class="distance-button text-center" @click="showInfo = !showInfo">
            <v-btn outlined block color="primary" >
              <v-icon v-if="!showInfo" >list_alt</v-icon>
              <v-icon v-else >public</v-icon>
            </v-btn>
          </div>
          <v-card class="distance-info elevation-0" :class="{'hideInfo': !showInfo}" >
              <div class="pa-3" >
              <div>
                <div class="distance-item-block pa-4 pl-6">
                  <v-datetime-picker
                  label="Date and time"
                  v-model="distanceInfo.date"
                  time-format="HH:mm"
                  date-format="dd/MM/yyyy"
                  :text-field-props="{ 'prepend-icon': 'events'}"
                  > </v-datetime-picker>
                </div>
              </div>
                  <div>
                    <div class="distance-item-block my-4 pa-4">
                    <v-autocomplete
                      v-bind:items="clients"
                      v-model="clientObj"
                      label="Select Client"
                      prepend-icon="person"
                      single-line
                      menu-props="bottom"
                      return-object
                      @change = "onChangeClient"
                      autocomplete
                      dense
                      hide-details
                      style="max-width:50%"
                    ></v-autocomplete>

                    <g-input
                      :index="1"
                      :id="'g-1'"
                      @placechanged="setPlace"
                      @remove="removeElement"
                      @add="addClient"
                      placeholder="Client address"
                      :clearable="true"
                      :addable="true"
                      :hideDetails="true"
                      prependIcon="place"
                      class="pb-3"
                    ></g-input>
                    </div>

                    <div class="distance-item-block my-4 pa-3">
                    <v-autocomplete
                      v-bind:items="destinations"
                      v-model="destinationObj"
                      label="Select Destination"
                      prepend-icon="location_city"
                      single-line
                      menu-props="bottom"
                      return-object
                      @change = "onChangeDestination"
                      autocomplete
                      dense
                      hide-details
                    ></v-autocomplete>



                      <g-input
                        :index="2"
                        :id="'g-2'"
                        @placechanged="setPlace"
                        @remove="removeElement"
                        @add="addDestination"
                        placeholder="Destination address"
                        :clearable="true"
                        :addable="true"
                        :hideDetails="true"
                        prependIcon="place"
                        class="pb-3"
                      ></g-input>

                    </div>

                    <div class="distance-item-block my-4 pa-3">
                    <v-autocomplete
                      v-bind:items="drivers"
                      v-model="driverObj"
                      label="Select Driver"
                      prepend-icon="directions_car"
                      single-line
                      menu-props="bottom"
                      return-object
                      @change = "onChangeDriver"
                      autocomplete
                      dense
                      hide-details
                      class="pb-3"
                    ></v-autocomplete>

                    <g-input v-show="driverObj"
                      :index="0"
                      :id="'g-0'"
                      @placechanged="setPlace"
                      @remove="removeElement"
                      placeholder="Driver address"
                      :clearable="true"
                      :hideDetails="true"
                      prependIcon="place"
                      class="pb-3"
                    ></g-input>
                  </div>

                 </div>

                </div>

                  <v-card v-show="false" id="mutas" ref="mutas" class="pt-3 elevation-0"></v-card>
                  <v-card id="output" class="elevation-0 pt-2"></v-card>
                  <div v-if="mutasPrice" class="text-right pa-3" style="">Prix mutuelle: {{ mutasPrice | currency}}</div>
          </v-card>
        </v-flex>
      </v-layout>

    </div>
    <div class="distance-map" :class="{'hideMap': showInfo}">

      <div id="map" style="border: solid 1px lightgrey; min-height: 350px;"></div>
    </div>
  </div>

</template>
<script>
import moment from 'moment';
import gInput from '@/components/googlemaps/gInput';
import Styles from '@/components/googlemaps/styles';
import RoutesMap from '@/components/googlemaps/RoutesMap';
import BookingMixin from '@/mixins/bookings'
import ClientsMixin from '@/mixins/clients'
import DestinationsMixin from '@/mixins/destinations'
import MutasMixin from '@/mixins/mutas'

export default {
  name: 'distance',
  mixins: [ClientsMixin, DestinationsMixin, BookingMixin, MutasMixin],
  components: {
    'g-input': gInput
  },
  data () {
    return {
      orginInput: [],
      destInput: [],
      waypts: [],
      counter: 0,
      limit: 5,
      initInputs: 3,
      routes: null,
      map: null,
      mapEl: null,
      places: [],
      inputs: [],
      placeholder: 'Vul jouw bestemming',
      driverObj: null,
      drivers: [],
      destinationObj: null,
      destinations: [],
      clientObj: null,
      clients: [],
      showInfo: false,
      mutasPrice: null,
      distanceInfo: {}
    };
  },
  methods: {
    createMap: function () {
      var i;
      this.mapEl = document.getElementById('map');
      this.map = new RoutesMap('map', Styles);
      // this.routes = new RoutesInput(places, this.map);
      for (i = 0; i < this.initInputs; i++) {
        this.addInput();
      }
    },
    addInput: function () {
      var counter = this.inputs.length;

      if (counter === this.limit) {
        alert('you have reached the limit of adding ' + counter + ' inputs');
      } else {
        this.inputs.push('g-' + counter++);
      }
    },
    removeInput: function (input) {
      this.routes.delete(input);
    },
    removeElement: function (index) {
      console.log(index);
      this.inputs.splice(index, 1);
      this.places.splice(index, 1);
      this.update();
    },

    setPlace: function (v) {
      this.update();
      console.log('setPlace', v);
      // console.log('getIndexes; ', this.map.getIndexes(3));
    },

    update: function () {
      this.places = [];
      for (var i = 0; i < this.inputs.length; i++) {
        // console.log('input:', this.inputs[i]);
        this.places[i] = document.getElementById(this.inputs[i]);
      }
      this.waypts = [];

      var inputs = this.places;
      if (inputs[0] && inputs[0].value && inputs[1].value && inputs[2].value) {
        this.orginInput = inputs[0].value;
        this.destInput = inputs[2].value;
        this.waypts.push({
              location: inputs[1].value,
              stopover: true
        });
        //this.waypts.push(inputs[1].value);
        // for (i = 1; i < inputs.length; i++) {
        //   if (inputs[i].value) {
        //     this.waypts.push({
        //       location: inputs[i].value,
        //       stopover: true
        //     });
        //     // this.waypts.push(inputs[i].value);
        //   }
        // }
        this.calcRoute();
      } else {
        this.map.reset();
      }
    },

    calcRoute: function () {
      this.map.update({
        orginInput: this.orginInput,
        destInput: this.destInput,
        waypts: this.waypts
      });
      // this.map.showRoute(this.places);

      this.getDirections(this.places);

      // this.getDistance(this.places)
    },
    getDistance: function (inputs) {
      var app = this;

      var data = inputs.reduce(function (filtered, input) {
        if (input.value) {
          filtered.push(input.value);
        }
        return filtered;
      }, []);

      console.log('getDistance', data);
      this.$http
      .post('service/distance/get', data)
      .then(response => {
        var data = this.calcEstimation(response.data)
        app.map.renderData(data);
        if (response.data.to[1]) {
          console.log('response data', response.data.to[1].trip.distance);
          app.calcMutas(response.data.to[1].trip.distance);

        }
        // app.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getDirections: function (inputs) {
      var app = this;
      var data = {
        origin: inputs[0].value,
        destination: inputs[0].value,
        waypoints: [inputs[1].value, inputs[2].value]
      }
      this.$http
      .post('service/distance/getDirections', data)
      .then(response => {
        app.buildInfo(response.data);
        // app.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    buildInfo (result) {
      if (result) {
        var data = this.calcEstimation(result)
        this.map.renderData(data);
        if (result.to[1]) {
          this.calcMutas(result.to[1].trip.distance);
        }
        this.distanceInfo.result = result
      }
    },
    getDrivers () {
      // var app = this;
      this.$http
      .get('api/driver')
      .then(response => {
        console.log('data', response.data);
        this.drivers = response.data.map(obj => {
          return {
            id: 'driverId',
            text: obj.lastname + ' ' + obj.firstname,
            value: obj.id,
            address: obj.address + ', ' + obj.zip + ' ' + obj.city
          }
        })
        // app.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getDestinations () {
      // var app = this;
      return new Promise((resolve, reject) => {
        this.$http
        .get('api/destination')
        .then(response => {
          console.log('data', response.data);
          this.destinations = response.data.map(obj => {
            return {
              id: 'destinationId',
              text: obj.name,
              value: obj.id,
              address: obj.fullAddress
            }
          })
          resolve(this.destinations);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    getCients () {
      return new Promise((resolve, reject) => {
        this.$http
        .get('api/client')
        .then(response => {
          this.clients = response.data.map(obj => {
            return {
              id: 'clientId',
              text: obj.lastname + ' ' + obj.firstname + ' ' + obj.id,
              value: obj.id,
              address: obj.address + ', ' + obj.zip + ' ' + obj.city,
              data: {
                factuur: obj.factuur,
                price: obj.basePrice
              }

            }
          });
          resolve(this.clients);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    onChangeClient (e) {
      var g = document.getElementById('g-1');
      g.value = e.address;
      console.log('onchange', e);
      this.update();
    },
    onChangeDriver (e) {
      var g = document.getElementById('g-0');
      g.value = e.address;
      console.log('onchange', e);
      this.update();
    },
    onChangeDestination (e) {
      var g = document.getElementById('g-2');
      g.value = e.address;
      console.log('onchange', e);
      this.update();
    },
    addClient () {
      this.dialog_client = true;
      if (this.places[1] && this.places[1].value) {
        this.clientItem.fullAddress = this.places[1].value;
      }
    },
    addDestination () {
      this.dialog_destination = true;
      if (this.places[2] && this.places[2].value) {
        this.destinationItem.fullAddress = this.places[2].value;
      }
    },
    calcEstimation (data) {
      this.mutasPrice = this.calcTarif(data.to[1].trip.distance * 1000);
      data.totals.to.price += 1;
      data.totals.to.price = data.totals.to.price < 10 ? 10 : data.totals.to.price;
      data.totals.total.price += 2;
      return data
    },
    buildInfoStored () {
      let stored = JSON.parse(localStorage.getItem('distanceInfo'));
       this.distanceInfo = stored || {};
       this.distanceInfo.date = this.distanceInfo.date ?  moment(this.distanceInfo.date).format('DD/MM/YYYY HH:mm') : moment().format('DD/MM/YYYY HH:mm');
      if (this.distanceInfo.result) {
        this.buildInfo(this.distanceInfo.result);
      }
    },
    getData () {
      return new Promise((resolve, reject) => {
        this.getDrivers();
        this.getCients().then(() => {
          this.getDestinations().then(() => {
            resolve(true)
          });
        })
        .catch(function (error) {
          reject(error);
        });
      })
    }
  },
  watch: {
    distanceInfo: {
      handler () {
        console.log('updated localStorage', 'distanceInfo');
        localStorage.setItem('distanceInfo', JSON.stringify(this.distanceInfo));
      },
      deep: true
    }
  },
  mounted () {
    // this.getDestinations().then(() => {
    //   this.getDrivers()
    //   this.createMap(this.places);
    // });
    this.getData().then(() => {
      this.createMap(this.places);
      this.buildInfoStored();
    })

    if (this.$route.query) {
      console.log('query:', this.$route.query);
    }

  }
};
</script>
<style lang="scss">
@import '@/components/googlemaps/distance.scss';
#distance {

  .distance-item-block {
    border: solid 1px lightgrey;
    background: #f5f5f5;
  }
}

</style>
